import watchDashboardSaga from './dashboard'
import watchPostLiveReasonSaga from './postLive'

export default () => [watchDashboardSaga(), watchPostLiveReasonSaga()]
